import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
interface PhoneEntryProps {
  onContinue: (phone: string) => void;
}
export function PhoneEntry({
  onContinue
}: PhoneEntryProps) {
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Malaysian numbers are typically 9-10 digits (e.g., 0123456789)
    if (phone.length < 9 || phone.length > 10) {
      setError('Please enter a valid Malaysian mobile number');
      return;
    }
    onContinue(phone);
  };
  return <div className="space-y-6" data-id="element-314">
      <div data-id="element-315">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-316">
          Continue to Maybank.
        </h1>
        <p className="text-gray-600" data-id="element-317">
          Enter your mobile number to access your Maybank account.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-318">
        <div className="flex space-x-4" data-id="element-319">
          <div className="w-28 flex-shrink-0" data-id="element-320">
            <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-321">
              Code
            </label>
            <div className="flex items-center justify-center h-[46px] w-full rounded-lg border border-gray-300 bg-gray-50 text-gray-900 font-medium" data-id="element-322">
              🇲🇾 +60
            </div>
          </div>
          <div className="flex-1" data-id="element-323">
            <Input label="Mobile number" type="tel" placeholder="012 345 6789" value={phone} onChange={e => {
            setPhone(e.target.value.replace(/\D/g, ''));
            setError('');
          }} error={error} autoFocus maxLength={10} data-id="element-324" />
          </div>
        </div>

        <Button type="submit" fullWidth disabled={!phone} data-id="element-325">
          Continue
        </Button>
      </form>
    </div>;
}